import { PostProperties } from "../types";
import image from "../img/lostGemCosminTrg.jpg";

const post: PostProperties = {
  id: 11,
  title: "Cosmin TRG - Live @ Concrete, Paris (26.02.2012)",
  content: " ",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/cosmin-trg-live-concrete-paris-26022012",
  category: "Lost Gem",
};

export default post;
